export const PHONE_WHATSAPP = "918918607016";
export const PHONE_CALL_TEL = "+918918607016";
export const PHONE_WHATSAPP_DISPLAY = "+91 89186 07016";
export const PHONE_CALL_DISPLAY = "+91 89186 07016";

export const waLink = (msg) =>
  `https://wa.me/${PHONE_WHATSAPP}?text=${encodeURIComponent(msg)}`;

export const WA_DEFAULT = waLink(
  "Hi Lift Edge team, I want to build a gym within my budget. Please guide me with the right Hercules Fitness equipment."
);

export const ADDRESS_LINES = [
  "City Plaza, Sevoke Road",
  "Opposite Payal Cinema Hall",
  "Near Indian Pagoda Restaurant",
  "Siliguri, West Bengal",
];

export const MAPS_DIRECTIONS =
  "https://www.google.com/maps/dir/?api=1&destination=City+Plaza,+Sevoke+Road,+Siliguri,+West+Bengal";

export const MAPS_EMBED =
  "https://maps.google.com/maps?q=City%20Plaza%2C%20Sevoke%20Road%2C%20Siliguri%2C%20West%20Bengal&t=&z=15&ie=UTF8&iwloc=&output=embed";

export const NAV_LINKS = [
  { label: "Home", hash: "#home", testid: "nav-link-home" },
  { label: "About", hash: "#about", testid: "nav-link-about" },
  { label: "Products", hash: "#products", testid: "nav-link-catalogue" },
  { label: "Services", hash: "#services", testid: "nav-link-services" },
  { label: "Why Us", hash: "#why-us", testid: "nav-link-why" },
  { label: "Contact", hash: "#contact", testid: "nav-link-location" },
];

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1689877020200-403d8542d95d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwyfHxneW0lMjBlcXVpcG1lbnQlMjBjb21tZXJjaWFsJTIwZml0bmVzcyUyMHdvcmtvdXQlMjBzaG93cm9vbSUyMHN0dWRpb3xlbnwwfHx8fDE3ODkxODc2MTR8MA&ixlib=rb-4.1.0&q=85",
  showroom:
    "https://images.unsplash.com/photo-1637430308606-86576d8fef3c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwxfHxneW0lMjBlcXVpcG1lbnQlMjBjb21tZXJjaWFsJTIwZml0bmVzcyUyMHdvcmtvdXQlMjBzaG93cm9vbSUyMHN0dWRpb3xlbnwwfHx8fDE3ODkxODc2MTR8MA&ixlib=rb-4.1.0&q=85",
  cardio:
    "https://images.unsplash.com/photo-1593079831268-3381b0db4a77?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHw0fHxneW0lMjBlcXVpcG1lbnQlMjBjb21tZXJjaWFsJTIwZml0bmVzcyUyMHdvcmtvdXQlMjBzaG93cm9vbSUyMHN0dWRpb3xlbnwwfHx8fDE3ODkxODc2MTR8MA&ixlib=rb-4.1.0&q=85",
  strength:
    "https://images.unsplash.com/photo-1558611848-73f7eb4001a1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxiYXJiZWxsJTIwcmFjayUyMHN0cmVuZ3RoJTIwdHJhaW5pbmclMjBneW0lMjBlcXVpcG1lbnR8ZW58MHx8fHwxNzg5MTg3NjIxfDA&ixlib=rb-4.1.0&q=85",
  accessories:
    "https://images.unsplash.com/photo-1590150392093-a552544eed09?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHw0fHxiYXJiZWxsJTIwcmFjayUyMHN0cmVuZ3RoJTIwdHJhaW5pbmclMjBneW0lMjBlcXVpcG1lbnR8ZW58MHx8fHwxNzg5MTg3NjIxfDA&ixlib=rb-4.1.0&q=85",
  treadmill:
    "https://images.unsplash.com/photo-1578874691223-64558a3ca096?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwyfHx0cmVhZG1pbGwlMjBjYXJkaW8lMjBtYWNoaW5lJTIwZml0bmVzcyUyMHdvcmtvdXQlMjBlcXVpcG1lbnR8ZW58MHx8fHwxNzg5MTg3NjIxfDA&ixlib=rb-4.1.0&q=85",
  functional:
    "https://images.unsplash.com/photo-1648995361141-30676a75fd27?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwxfHx0cmVhZG1pbGwlMjBjYXJkaW8lMjBtYWNoaW5lJTIwZml0bmVzcyUyMHdvcmtvdXQlMjBlcXVpcG1lbnR8ZW58MHx8fHwxNzg5MTg3NjIxfDA&ixlib=rb-4.1.0&q=85",
  facility:
    "https://images.unsplash.com/photo-1728486145245-d4cb0c9c3470?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwzfHxneW0lMjBlcXVpcG1lbnQlMjBjb21tZXJjaWFsJTIwZml0bmVzcyUyMHdvcmtvdXQlMjBzaG93cm9vbSUyMHN0dWRpb3xlbnwwfHx8fDE3ODkxODc2MTR8MA&ixlib=rb-4.1.0&q=85",
};

export const MARQUEE_ITEMS = [
  "We Build Your Gym According to Your Budget",
  "Exclusive Hercules Fitness Showroom",
  "Delivery — North Bengal · Sikkim · Bihar · West Bengal · Nepal · Bhutan",
  "Complete Gym Setups",
  "Strength",
  "Cardio",
  "Functional Training",
  "Accessories",
  "Expert Guidance",
  "Reliable After-Sales Service",
];

export const WHY_US = [
  {
    icon: "BadgeCheck",
    title: "Quality Equipment",
    text: "Trusted fitness equipment designed for performance, durability and long-term use.",
  },
  {
    icon: "Boxes",
    title: "Complete Fitness Solutions",
    text: "From individual equipment to complete gym setups, we help you find the right solution for your space and requirements.",
  },
  {
    icon: "ShieldCheck",
    title: "Reliable After-Sales Service",
    text: "Our relationship doesn\u2019t end after your purchase. We provide dependable support whenever you need us.",
  },
  {
    icon: "Compass",
    title: "Expert Guidance",
    text: "Our team helps you choose equipment according to your requirements, available space, usage and budget.",
  },
  {
    icon: "MapPin",
    title: "Wide Delivery Network",
    text: "Serving customers across North Bengal, Sikkim, Bihar, West Bengal, Nepal and Bhutan with quality fitness equipment and professional support.",
  },
  {
    icon: "HeartHandshake",
    title: "Customer First",
    text: "We believe in honest communication, responsive service and long-term customer relationships.",
  },
];

export const PRODUCT_SEGMENTS = [
  {
    key: "commercial",
    title: "Commercial Fitness Solutions",
    tagline:
      "Heavy-duty Hercules Fitness series engineered for gyms, clubs and high-traffic professional training floors.",
    img: IMAGES.strength,
    groups: [
      {
        name: "Signature Series",
        items: [
          "Apex",
          "Aristo",
          "Armour",
          "Armour Plate Loaded",
          "Aura",
          "Dior",
          "DNA",
          "Eclipse",
          "Flexion",
          "Forge",
          "Fusion",
          "Grit",
          "Razor",
          "Royale Plate Loaded",
          "Stoic Plate Loaded",
          "Stoic Pin Loaded",
          "Vital Pro",
          "Wave",
        ],
      },
      {
        name: "Commercial Cardio",
        items: [
          "Treadmills",
          "Elliptical Trainers",
          "Upright Bikes",
          "Recumbent Bikes",
          "Spin Bikes",
          "Air Bikes",
          "Rowing Machines",
          "Stair Climbers",
        ],
      },
      {
        name: "Strength & Recovery",
        items: ["Multi Gyms", "Benches", "Plate Loaded Machines", "Massage Chairs"],
      },
    ],
  },
  {
    key: "home",
    title: "Fitness For Your Home",
    tagline:
      "Compact, reliable Hercules Fitness equipment built for personal training spaces and home gyms.",
    img: IMAGES.treadmill,
    groups: [
      {
        name: "Home Cardio",
        items: [
          "Treadmills",
          "Manual Treadmills",
          "Multi-Function Treadmills",
          "Elliptical Trainers",
          "Exercise Bikes",
          "Air Bikes",
          "Upright Bikes",
          "Recumbent Bikes",
          "Dual Bikes",
          "Spin Bikes",
        ],
      },
      { name: "Home Strength", items: ["Multi Gyms", "Benches"] },
    ],
  },
  {
    key: "hospitality",
    title: "Hospitality & Business Solutions",
    tagline:
      "Curated Hercules Fitness equipment packages for hotels, institutions and corporate wellness spaces.",
    img: IMAGES.cardio,
    groups: [
      {
        name: "For Hotels & Institutions",
        items: [
          "Treadmills",
          "Elliptical Trainers",
          "Upright Bikes",
          "Recumbent Bikes",
          "Spin Bikes",
          "Multi Gyms",
          "Benches",
        ],
      },
    ],
  },
  {
    key: "accessories",
    title: "Accessories",
    tagline: "Everything that completes the floor — from dumbbells to boxing bags.",
    img: IMAGES.accessories,
    groups: [
      {
        name: "Training Accessories",
        items: [
          "Dumbbells",
          "Weight Plates",
          "Bars & Rods",
          "Mats & Ropes",
          "Fitness Balls",
          "Boxing Bags",
          "More Accessories",
        ],
      },
    ],
  },
];

export const SERVICES = [
  {
    icon: "ClipboardList",
    title: "Gym Setup Consultation",
    text: "Plan your equipment requirements according to available space, target users and budget.",
  },
  {
    icon: "Dumbbell",
    title: "Equipment Selection",
    text: "Guidance toward suitable equipment based on your training and business requirements.",
  },
  {
    icon: "Truck",
    title: "Equipment Supply",
    text: "Professional supply of fitness equipment across North Bengal, Sikkim, Bihar, West Bengal, Nepal and Bhutan.",
  },
  {
    icon: "Wrench",
    title: "Installation & Support",
    text: "Installation assistance and ongoing support where applicable.",
  },
  {
    icon: "LifeBuoy",
    title: "After-Sales Service",
    text: "Prompt and dependable service to keep your equipment functioning smoothly.",
  },
  {
    icon: "TrendingUp",
    title: "Upgrade & Expansion",
    text: "Helping existing gyms and fitness facilities upgrade or expand their equipment setup.",
  },
];

export const REVIEWS = [
  {
    name: "Sekmey Singh",
    time: "a year ago",
    text: "Modern equipments and extraordinary service. I am giving it all 5 stars as I trust them the most when it comes to fitness products and equipments. 10 on 10.",
  },
  {
    name: "Subham Kumar Prasad",
    time: "a year ago",
    text: "One of the best fitness equipment stores in entire Siliguri with best service and best products — my experience and genuine review. Never disappointed.",
  },
  {
    name: "Nikita Limboo",
    time: "7 months ago",
    text: "Best store in town. All the products are of the best quality.",
  },
  {
    name: "Chinku Sarkar",
    time: "10 months ago",
    text: "Best fitness store, I would recommend this fitness showroom to anyone looking for the best equipments.",
  },
  {
    name: "Sarita Tamang",
    time: "10 months ago",
    text: "Best fitness store in Siliguri.",
  },
  {
    name: "Annu Anuraj Goyal",
    time: "10 months ago",
    text: "Good products at best price.",
  },
  {
    name: "Parul Maiya",
    time: "a year ago",
    text: "One stop solution for all your fitness needs!!",
  },
];

export const REQUIREMENT_OPTIONS = [
  "Complete Gym Setup",
  "Strength Equipment",
  "Cardio Equipment",
  "Functional Training",
  "Fitness Accessories",
  "Service / Support",
  "Other",
];

const HF = "https://herculesfitness.co.in";
const HFU = `${HF}/wp-content/uploads`;

export const FEATURED_PRODUCTS = {
  commercial: [
    {
      name: "TDU 2200 Commercial Treadmill",
      type: "Commercial Cardio",
      img: `${HFU}/2026/03/tdu2200.png`,
      link: `${HF}/products/commercial-fitness-solutions/treadmills-commercial-fitness-solutions/tdu2200/`,
      specs: [["Motor Power", "1.25 HP / 2.5 HP Peak DC Motor"], ["Machine Size", "1340 × 660 × 1250 mm"], ["Running Area", "1100 × 420 mm"], ["Incline", "Manual Incline 3Levels"], ["Speed Range", "1 – 12 km/h"], ["Machine Weight", "43Kg"], ["Maximum User Weight", "120Kg"], ["Belt Thickness", "1.4mm"], ["Frame Material", "Heavy-Duty Steel"], ["Display", "3 Window LED Display"]],
    },
    {
      name: "EPH 750 Commercial Elliptical",
      type: "Commercial Cardio",
      img: `${HFU}/2026/03/image5.png`,
      link: `${HF}/products/commercial-fitness-solutions/elliptical-trainer-commercial-fitness-solutions/eph750/`,
      specs: [["Drive Type", "Front Drive"], ["Fly Wheel Weight", "10Kg"], ["Resistance Type", "PMS Magnetic"], ["Resistance Control", "Electronic"], ["Machine Size", "1700 × 600 × 1800 mm"], ["Resistance Levels", "1–32 Levels"], ["Machine Weight", "101.4 kg"], ["Maximum User Weight", "150Kg"], ["Frame Material", "Heavy-Duty Steel/3 Mm (Bottom Tube), 2 Mm (Other Tubes)"], ["Display", "LCD"]],
    },
    {
      name: "RBP 70 Recumbent Bike",
      type: "Commercial Cardio",
      img: `${HFU}/2022/06/rbp70.png`,
      link: `${HF}/products/commercial-fitness-solutions/recumbent-bike-commercial-fitness-solutions/rbp70/`,
      specs: [["Electro Magnetic System"], ["Auto Magnetic Resistance Control"], ["16 Kgs. Fly Wheel"], ["Hand Held Heart Rate Sensor"], ["Machine weight-67.8kgs"], ["Maximum User Weight", "170 Kgs."], ["Key Functions"], ["Super Quiet Poly V belt Drive for smooth function"], ["Targets Lower Body"], ["Transportation Wheel"]],
    },
    {
      name: "Forge FO29 Shoulder & Chest Press",
      type: "Forge Series",
      img: `${HFU}/2024/12/FO29.png`,
      link: `${HF}/products/commercial-fitness-solutions/forge-series/forge-fo29-shoulder-press-and-seated-chest-press/`,
      specs: [["Machine Size", "59\" × 78\" × 64\""], ["Net Weight", "277 kg"], ["Weight Stack", "100 kg"]],
    },
    {
      name: "Stoic Lateral Bench Press",
      type: "Stoic Plate Loaded",
      img: `${HFU}/2024/07/lateral-bench.png`,
      link: `${HF}/products/commercial-fitness-solutions/stoic-plate-loaded/stoic-lateral-bench-press/`,
      specs: [["Machine Floor Size", "63\" x 50\" x 82\""], ["Machine Weight", "140Kg"], ["Frame Size", "50*80*2.0T Rectangular Tube"], ["Cushion", "Made of PU"], ["Handlebar", "Covered with TPV Thermoplastic elastic material"], ["Multi-Level Adjustment available"]],
    },
    {
      name: "Adler MC50 Massage Chair",
      type: "Recovery",
      img: `${HFU}/2023/11/ADLER-MC50-LH.png`,
      link: `${HF}/products/commercial-fitness-solutions/massager-chair/full-body-massager-chair/`,
      specs: [["Full Body Massage Chair For Home And Office With Luxury 3D Space Saving Design."], ["Wide Roller Coverage"], ["Compact & Handy Remote With Full Customization."], ["Option To Target Specific Zones On Your Back With Any Massaging Mode."], ["Expert Stretching Massage For Back And Leg"], ["Key Functions"], ["Multiple Cushion"]],
    },
  ],
  home: [
    {
      name: "Adler T2200 Treadmill",
      type: "Home Cardio",
      img: `${HFU}/2023/10/ADLER-T2200-Black-Blue-LH.png`,
      link: `${HF}/products/fitness-for-your-home/treadmills-fitness-for-your-home/adler-t2200/`,
      specs: [["Machine Floor Size 64” x 29\" x53”"], ["1.5 HP / 2 HP BLDC Motor"], ["16 Km/hr. Max. Speed"], ["3 level manual incline"], ["48” x 18\" Extra Wide Running Area"], ["Maximum User Weight", "110 Kgs."], ["Machine weight - 50 kgs"], ["MP3 player"], ["Foldable Structure"], ["Heart Rate Measurement"]],
    },
    {
      name: "TMN 11 Manual Treadmill",
      type: "Home Cardio",
      img: `${HFU}/2022/06/tmn11.png`,
      link: `${HF}/products/fitness-for-your-home/manual-treadmill/tmn11/`,
      specs: [["Multi Function"], ["4 Functions", "Treadmill, Twister, Push-up Bar and Stepper"], ["3 Level Manual Incline"], ["47” x 14” wide Running Area"], ["LCD Display"], ["Hand Held Heart Rate Sensor"], ["Maximum User Weight", "100 Kgs."], ["Machine Weight", "42kgs"], ["Key Functions"], ["Multi Window Display", "Time, Speed, Distance, Calorie and Pulse"]],
    },
    {
      name: "Adler EX27 Elliptical",
      type: "Home Cardio",
      img: `${HFU}/2023/10/ADLER-EX27-Black-Blue-combination-LH.png`,
      link: `${HF}/products/fitness-for-your-home/elliptical-trainer/adler-ex27/`,
      specs: [["Magnetic Tension"], ["Machine floor size -65” x 27\" x 66”"], ["8 level Manual Magnetic Resistance Control"], ["Fly Wheel - 10 Kgs"], ["Crank Design - Heavy Duty Centre Axle"], ["Hand Held Heart Rate Sensor"], ["Maximum User Weight - 115 Kgs"], ["Machine weight - 57 Kgs"], ["Stride length – 18"], ["Key Functions"]],
    },
    {
      name: "Adler MB20 Upright Bike",
      type: "Home Cardio",
      img: `${HFU}/2023/10/ADLER-MB20-Black-Blue-combination-LH.png`,
      link: `${HF}/products/fitness-for-your-home/upright-bike-fitness-for-your-home/adler-mb20/`,
      specs: [["Machine floor size 39” x 22\" x 51”"], ["8 Level Manual Magnetic Resistance Control"], ["Uni Crank Design"], ["Fly Wheel 6 Kgs."], ["Machine weight-29kgs"], ["Maximum User Weight", "110 Kgs."], ["Hand Held Heart Rate Sensor"], ["Stride length -7"], ["Key Functions"], ["Single Window Display – Time, Distance, Speed, Calorie & Pulse"]],
    },
    {
      name: "DB22 Dual Bike",
      type: "Home Cardio",
      img: `${HFU}/2022/06/DB22-1.png`,
      link: `${HF}/products/fitness-for-your-home/dual-bikes/db22/`,
      specs: [["Chain Drive"], ["MULTI Function – Cycling, Elliptical, Twister, Push-up, Band & Dumbbells"], ["Manual Resistance Control"], ["Single Window Display – Time, Distance, Speed, Calorie"], ["Uni-Crank Design"], ["Hand Held Heart Rate Sensor"], ["Maximum User Weight", "90 Kgs."], ["Machine weight-36kgs"], ["Key Functions"], ["Vertical Seat Adjustment"]],
    },
    {
      name: "SM110 Home Multi Gym",
      type: "Home Strength",
      img: `${HFU}/2023/08/1FH329U0337000A-2.png`,
      link: `${HF}/products/fitness-for-your-home/multi-gym-fitness-for-your-home/sm110/`,
      specs: [["Multi Function"], ["150 Lbs Weight Stack"], ["2000 Lbs Tensile Strength Cables"], ["Tricep Extension"], ["Lat"], ["Pec Deck"], ["Bench Press"], ["Chest Press"], ["Seated Row"], ["Leg Extension"]],
    },
  ],
  hospitality: [
    {
      name: "EL 60 Elliptical Trainer",
      type: "Hospitality Cardio",
      img: `${HFU}/2023/02/el60.png`,
      link: `${HF}/products/hospitality-business-solutions/elliptical-trainer-hospitality-business-solutions/el-60/`,
      specs: [["Electro Magnetic System"], ["Dual Function", "Cycling & Elliptical"], ["Manually Adjustable Magnetic Resistance Control 12 Kgs. Fly Wheel"], ["Single Window Display – Time, Distance, Speed, Calorie & Pulse"], ["Hand Held Heart Rate Sensor"], ["Maximum User Weight", "140 Kgs."], ["Key Functions"], ["Targets Upper and Lower Body"], ["Large LED Display"], ["Horizontal & Vertical Seat Adjustment"]],
    },
    {
      name: "RBP 60 Recumbent Bike",
      type: "Hospitality Cardio",
      img: `${HFU}/2022/06/rbp60.png`,
      link: `${HF}/products/hospitality-business-solutions/recumbent-bike-hospitality-business-solutions/rbp60/`,
      specs: [["Electro Magnetic System"], ["Auto Magnetic Resistance Control"], ["Fly Wheel - 15 Kgs"], ["Hand Held Heart Rate Sensor"], ["Machine weight- 49.5kgs"], ["Maximum User Weight", "150 Kgs."], ["Key Functions"], ["Easy Saddle Slide Movement"], ["Super Quiet Poly V belt Drive for smooth function"], ["Targets Lower Body"]],
    },
    {
      name: "UBP 60 Upright Bike",
      type: "Hospitality Cardio",
      img: `${HFU}/2022/06/ubp60.png`,
      link: `${HF}/products/hospitality-business-solutions/upright-bike/ubp60/`,
      specs: [["Electro Magnetic System"], ["Auto Magnetic Resistance Control"], ["Fly Wheel 15 Kgs"], ["Machine weight-35kgs"], ["Hand Held Heart Rate Sensor"], ["Maximum User Weight", "150 Kgs."], ["Key Functions"], ["Vertical and Horizontal Seat Adjustment"], ["Adjustable Handlebar Angle"], ["Targets Lower Body"]],
    },
    {
      name: "SM 208 Multi Gym",
      type: "Hospitality Strength",
      img: `${HFU}/2022/06/sm208-1.png`,
      link: `${HF}/products/hospitality-business-solutions/multi-gym-hospitality-business-solutions/sm208/`,
      specs: [["Multi Function"], ["160 Lbs Weight Stack"], ["2000 Lbs Tensile Strength Cables"], ["Tricep Extension"], ["Lat"], ["Pec Deck"], ["Bench Press"], ["Chest Press"], ["Seated Row"], ["Leg Extension"]],
    },
    {
      name: "SB 20 Spin Bike",
      type: "Hospitality Cardio",
      img: `${HFU}/2022/06/SB20-RH.png`,
      link: `${HF}/products/hospitality-business-solutions/spin-bikes/sb20/`,
      specs: [["Belt Drive"], ["Brush Brake Resistance Control"], ["Fly Wheel 13 Kgs"], ["Single Window Display – Time, Distance, Speed, Calorie"], ["Crank Design Heavy Duty 3 Pcs"], ["Maximum User Weight", "110 Kgs."], ["Machine weight -26.5 kgs"], ["Key Functions"], ["Vertical and Horizontal Seat Adjustment"], ["Adjustable Handlebar Angle"]],
    },
    {
      name: "MP 100 Bench",
      type: "Hospitality Strength",
      img: `${HFU}/2022/06/MP100-RH.png`,
      link: `${HF}/products/hospitality-business-solutions/benches-hospitality-business-solutions/mp100/`,
      specs: [["Abdominal Fitness Bench"], ["Thick padding for superior support"], ["Weight Training"], ["Adjustable Flat Incline Decline Weight Lifting Exercise"], ["Key Functions"], ["Cushion Seat / Better comfort"], ["Body Shape workout"], ["Ab Crunch"], ["Easy Installation"]],
    },
  ],
  accessories: [
    {
      name: "Hexagon Dumbbells",
      type: "Free Weights",
      img: `${HFU}/2024/07/2T2A0135.png`,
      link: `${HF}/products/accessories/hexagon-dumbbells/`,
      specs: [["Available Sizes", "2.5KG, 5KG, 7.5KG, 10KG, 12.5KG"]],
    },
    {
      name: "TPU Dumbbells",
      type: "Free Weights",
      img: `${HFU}/2024/07/2T2A0205.png`,
      link: `${HF}/products/accessories/tpu-dumbbells/`,
      specs: [["Available Sizes", "2.5KG, 5KG, 7.5KG, 10KG, 12.5KG, 15KG, 17.5KG, 20KG, 25KG, 30KG"]],
    },
    {
      name: "Bumper Plate 51mm",
      type: "Weight Plates",
      img: `${HFU}/2024/07/2T2A0221.png`,
      link: `${HF}/products/accessories/plates/bumper-plate-51mm/`,
      specs: [["Available Sizes", "5KG, 10KG, 15KG, 20KG, 25KG"]],
    },
    {
      name: "Weight Plate 51mm TPU",
      type: "Weight Plates",
      img: `${HFU}/2024/07/2T2A0213.png`,
      link: `${HF}/products/accessories/plates/weight-plate-51mm-tpu/`,
      specs: [["Available Sizes", "2.5KG, 5KG, 10KG, 15KG, 20KG, 25KG"]],
    },
    {
      name: "Medicine Ball",
      type: "Functional",
      img: `${HFU}/2024/07/2T2A0257.png`,
      link: `${HF}/products/accessories/fitness-ball/medicine-ball/`,
      specs: [["Available Sizes", "3KG, 4KG, 5KG, 6KG, 8KG, 10KG"]],
    },
    {
      name: "Balance Ball",
      type: "Functional",
      img: `${HFU}/2024/12/Balance-Ball.png`,
      link: `${HF}/products/accessories/fitness-ball/balance-ball/`,
      specs: [["Type", "Anti-burst balance / stability ball"], ["Use", "Core, balance & rehab training"]],
    },
    {
      name: "Yoga Mat",
      type: "Mats & Ropes",
      img: `${HFU}/2024/07/2T2A0185.png`,
      link: `${HF}/products/accessories/mats-rope/yoga-mat/`,
      specs: [["Variants", "Classic & Premium"], ["Thickness", "1.0 cm / 1.5 cm"], ["Size", "173 × 61 cm / 183 × 61 cm"]],
    },
    {
      name: "Jump Rope — Foam Handle",
      type: "Mats & Ropes",
      img: `${HFU}/2024/07/JUMP-ROPE-FOAM-HANDLE-2750-MM-1.png`,
      link: `${HF}/products/accessories/mats-rope/jump-rope-with-foam-handle/`,
      specs: [["Handle", "Comfort foam grip"], ["Use", "Cardio, warm-up & conditioning"]],
    },
  ],
};
